
const init = () => {
  jQuery("div[data-top-banner] > span").on("click", function(e) {
    e.preventDefault();
    jQuery("div[data-top-banner]").remove();
    Cookies.set("hide-announcement-banner", true);
  });


  // unhide top banner
  var hideTopBannerCookie = Cookies.get("hide-announcement-banner");
  if (
    typeof hideTopBannerCookie == "undefined" ||
    hideTopBannerCookie != "true"
  ) {
    jQuery("[data-top-banner]").removeClass("hidden");
  }
}
export default init
